/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrganizationPaymentCardInfoFromJSON, OrganizationPaymentCardInfoToJSON } from './OrganizationPaymentCardInfo';
export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSON(json) {
    return UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSONTyped(json, false);
}
export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        card: OrganizationPaymentCardInfoFromJSON(json['card'])
    };
}
export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        card: OrganizationPaymentCardInfoToJSON(value.card)
    };
}
